import cn from "app/utils/classnames";

interface MenuButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  icon?: React.ReactNode;
  elevation?: "lg" | "md" | "sm" | "cn";
  className?: string;
  forcePressed?: boolean;
}

export default function MenuButton({
  onClick = () => {},
  children,
  icon = undefined,
  elevation = "lg",
  className = "",
  forcePressed = false,
}: MenuButtonProps) {
  return (
    <button
      className={cn(
        "font-mono uppercase",
        "h-10",
        "pl-1.5 pr-2 py-1",
        "border border-black rounded-md",
        "transition-all",
        "flex justify-evenly items-center gap-1",
        "cursor-pointer",
        getElevationClassName(elevation, forcePressed),
        className
      )}
      onClick={onClick}
    >
      {icon && <div className={cn("shrink")}>{icon}</div>}
      {children}
    </button>
  );
}

function getElevationClassName(
  elevation: "lg" | "md" | "sm" | "cn",
  forcePressed: boolean
): string {
  if (forcePressed) {
    return "shadow-[0px_0px_0px_0px_black] translate-[0px]";
  }

  switch (elevation) {
    case "lg":
      return "shadow-[4px_4px_0_0px_black] active:shadow-[0px_0px_0px_0px_black] -translate-[4px] active:translate-[0px]";
    case "md":
      return "shadow-[2px_2px_0_0px_black] active:shadow-[0px_0px_0px_0px_black] -translate-[2px] active:translate-[0px]";
    case "sm":
      return "shadow-[1px_1px_0_0px_black] active:shadow-[0px_0px_0px_0px_black] -translate-[1px] active:translate-[0px]";
    case "cn":
      return "shadow-[0px_6px_0_0px_black] active:shadow-[0px_0px_0px_0px_black] -translate-y-[6px] active:translate-[0px]";
  }
}
